module.exports = __webpack_public_path__ + "media/application/images/iso-image-2023-76e9cd47c2084e8a79a791266ff0096d.png";